import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useDarkMode } from '@/composables/darkMode'
    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const { darkModeEnabled } = useDarkMode()

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app", { dark: _unref(darkModeEnabled) }])
  }, [
    _createVNode(_component_router_view)
  ], 2))
}
}

})